import { FiltersState, InFilterDefinition } from '@factorialco/f0-react'
import {
  AttendanceEmployeeFiltersInput,
  TimeInsightsValueObjectsInconsistencyTypeEnum,
} from 'generated/resources/graphql'

import {
  type TimeInsightsInconsistencyTypeFilter,
  managedByEmployeeEnum,
} from 'modules/attendance/components/TimeTrackingCollection/hooks/useFilters'

import { STATUS_FILTER_VALUES } from './constants'

type StringInFilter = InFilterDefinition<string>
type NumberInFilter = InFilterDefinition<number>
type BooleanInFilter = {
  type: 'in'
  label: string
  options: {
    options: {
      label: string
      value: boolean
    }[]
  }
}

export type CollectionFilters = FiltersState<{
  team: NumberInFilter
  workplace: NumberInFilter
  legalEntity: NumberInFilter
  reviewStatus: StringInFilter
  directReports: StringInFilter
  status: StringInFilter
  workedLess: BooleanInFilter
  reportingTo?: NumberInFilter
  alerts?: TimeInsightsInconsistencyTypeFilter
}>

export const transformFiltersToEmployeeFiltersInput = (
  filters: CollectionFilters,
  search?: string
): AttendanceEmployeeFiltersInput => {
  const teamIds = filters.team?.map((id) => Number(id))
  const locationIds = filters.workplace?.map((id) => Number(id))
  const legalEntityIds = filters.legalEntity?.map((id) => Number(id))
  const reportingToIds = filters.reportingTo?.map((id) => Number(id))
  const reviewStatus = filters.reviewStatus?.length ? filters.reviewStatus : undefined

  const onlyActive = filters.status?.includes(STATUS_FILTER_VALUES.ONLY_ACTIVE) ?? false
  const onlyNonAttendable =
    filters.status?.includes(STATUS_FILTER_VALUES.ONLY_NON_ATTENDABLE) ?? false
  const terminated = filters.status?.includes(STATUS_FILTER_VALUES.TERMINATED) ?? false

  const onlyDirectReports =
    filters.directReports?.includes(managedByEmployeeEnum.managed_directly_by_me) ?? false

  const hasWorkedLessThanPlanned = filters.workedLess?.includes(true) ? true : undefined

  const timeInsightsInconsistencyTypes:
    | TimeInsightsValueObjectsInconsistencyTypeEnum[]
    | undefined = filters.alerts?.length ? filters.alerts : undefined

  return {
    teamIds: teamIds && teamIds.length > 0 ? teamIds : undefined,
    locationIds: locationIds && locationIds.length > 0 ? locationIds : undefined,
    legalEntityIds: legalEntityIds && legalEntityIds.length > 0 ? legalEntityIds : undefined,
    reportingToIds: reportingToIds && reportingToIds.length > 0 ? reportingToIds : undefined,
    reviewStatus: reviewStatus && reviewStatus.length > 0 ? reviewStatus : undefined,
    onlyActive,
    onlyNonAttendable,
    terminated,
    onlyDirectReports,
    hasWorkedLessThanPlanned,
    search: search && search.length > 0 ? search : undefined,
    timeInsightsInconsistencyTypes:
      timeInsightsInconsistencyTypes && timeInsightsInconsistencyTypes.length > 0
        ? timeInsightsInconsistencyTypes
        : undefined,
  }
}
